import script from "./tipModal.vue?vue&type=script&setup=true&lang=js"
export * from "./tipModal.vue?vue&type=script&setup=true&lang=js"

import "./tipModal.vue?vue&type=style&index=0&id=2685241f&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2685241f"]])

export default __exports__